import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  category: string;
  author: string;
  status: string;
  rating: number;
  views: number;
  cover: string;
}

export default function ComicCard({ id, title, category, author, status, rating, views, cover }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          title={`${title} - 韩漫画网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            status === '连载中' ? 'bg-accent-500 text-background-50' : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-full bg-background-50/90 text-primary-600 text-xs font-bold whitespace-nowrap">
            {rating}
          </span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-xs text-foreground-500">{author}</span>
        <span className="text-xs text-foreground-400">
          <i className="ri-eye-line mr-0.5"></i>
          {formatViews(views)}
        </span>
      </div>
    </Link>
  );
}